module.exports = __webpack_public_path__ + "static/media/wac_logo_full.4d95ff52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wac_logo_full.png
// module id = 258
// module chunks = 0